import { Province } from '@app/types/province';
import { EnhancedPayrollReport } from '@reporting/interfaces/report.interface';
import { getInitialDatesByLastPaidCheque } from '../dates';

export const EPT_REPORT_PROVINCES: Province[] = ['ON', 'QC', 'MB', 'BC', 'NL'];

export type EPTReport = EnhancedPayrollReport & {
    jurisdiction: Province;
};

export type EPTReportJurisdiction = {
    [key in Province]?: {
        name: string;
        display_name: string;
        registration_url: string;
        filing_url: string;
        payment_url: string;
    };
};

const createEptByJurisdictionReporting = (province: Province): EPTReport => ({
    name: `reporting.payroll.ept.${province}.name`,
    description: `reporting.payroll.ept.${province}.description`,
    routerLink: ['ept-review', `${province}`],
    reportName: 'employerPayrollTaxReport',
    fileName: '',
    hasExcel: false,
    hasPDF: false,
    hasCSV: true,
    allowsInclusionOfPendingPayrolls: false,
    showsPeriod: false,
    filterable: true,
    isAnnual: true,
    jurisdiction: province,

    getInitialDates: getInitialDatesByLastPaidCheque,
});

export const EPT_REPORTS: readonly EPTReport[] = EPT_REPORT_PROVINCES.map(createEptByJurisdictionReporting);
